import React from "react";
import XRouterLink from "../../common/seo/xrouter/XRouterLink";
import { getEventUrl } from "../../utils/getEventUrl";
import Jersey from "../../data/jerseys/Jersey";
import StatsButton from "../../common/StatsButton";
import { getConfiguration } from '../../data/utils/configuration';
import LiveScoresInlineNewWh from "../../common/LiveScoresInlineNewWh";

export default function EventInfo(props) {
    const e = props.data;
    const streamingId = props.streamingId;
    const conf = getConfiguration();
    
    return (
        <>
            <div className="flex items-center w-full">
                {conf.iwh ?
                <>
                    <div className="font-normal text-xxs text-cs9">
                        {e.isLive && e.score?.periodo ? (
                            <>
                                {e.score.periodo} <span className="live__badge-inline">{e.score.periodo !== 'Int.' && e.score.currentMinute && ' - '}{e.score.currentMinute}</span>
                            </>
                        ) : (
                            e.time
                        )}
                    </div></>
                :
                <div className="font-normal text-xxs text-cs9">{e.dateShortYear} {e.time}</div>
            }
                <div className="ml-1 font-bold text-xxs text-cs9">|</div>
                <div className="ml-1 font-bold text-xxs text-cs9">{e.alias}</div>
            </div>
            <div className="w-full flex flex-col truncate">
                <div className="xs_teamsContainer w-full flex items-center justify-between truncate">
                    {e.score && conf.iwh &&
                        <LiveScoresInlineNewWh data={e.score} sportType={e.sportDesc} />
                    }
                    {e.team2?.length > 0 ?
                        <XRouterLink to={getEventUrl(e)} data={e} state={e} className="w-full flex flex-col truncate">
                            <div className="flex items-center">
                                <Jersey data={e.jerseys?.[0]} type={'home'} sportRef={e.sportRef} />
                                <span className="font-medium text-xs text-cs10 truncate">{conf.iwh && e.score?.srv === 1  ? <><span className='team1-srv'></span><span className="text-srv">{e.team1}</span></> : e.team1}</span>
                            </div>
                            <div className="flex items-center mt-1">
                                <Jersey data={e.jerseys?.[1]} type={'away'} sportRef={e.sportRef} />
                                <span className="font-medium text-xs text-cs10 truncate">{conf.iwh && e.score?.srv === 2  ? <><span className='team2-srv'></span><span className="text-srv">{e.team2}</span></> : e.team2}</span>
                            </div>
                        </XRouterLink>
                        :
                        <XRouterLink to={getEventUrl(e)} data={e} state={e} className="h-full flex flex-col justify-start truncate">
                            <div className="flex items-center">
                                <span className="font-medium text-xs text-cs10 truncate">{e.team1}</span>
                            </div>
                        </XRouterLink>
                    }
                    {streamingId && <i className="bi-tv" />}
                </div>
                {!conf.iwh &&
                    <div className="w-full flex shrink-0 items-center justify-between text-cs9">
                        <div>
                            <span className="text-xxs">
                                +{e.plus}
                            </span>
                            <i className="ml-1 bi-chevron-right text-xxs" />
                        </div>
                        <StatsButton match={e} />
                    </div>
                }
            </div>
        </>
    );
}
